import * as t from 'io-ts';
import { authorizedTo, id, meta, users } from '../..';

const data = t.type({
  title: t.string,
  users,
  permissions: t.array(t.string),
  scimRoleIdentifier: t.union([t.null, t.string]),
  entityItemRestricted: t.boolean,
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  users: t.array(t.number),
  permissions: t.array(t.string),
  scimRoleIdentifier: t.union([t.null, t.string]),
  entityItemRestricted: t.boolean,
});
